export const KneeHydropsText = {
  values: [
    { value: 'KneeHydrops', text: 'Ja', score: 1 },
    { value: 'KneeHydrops', text: 'Nei', score: 0 },
    { value: 'KneeHydrops', text: 'Ikke aktuelt', score: -1 },
  ],
};
